import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export function useArchiveConversation() {
  const queryClient = useQueryClient();

  const {
    mutate,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: unknown }, Error, { id: string; archived: boolean }>({
    mutationFn: ({ id, archived }) => api.put(`conversations/${id}/archive`, { archived }),
    onError: archiveError =>
      notifyAndLogError(
        'Could not update chat',
        'The chat could not be updated. Please try again.',
        archiveError,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });

  const setArchived = (id: string, archived: boolean) => mutate({ id, archived });

  return { setArchived, error, isLoading, reset };
}
